import axios from 'axios';
import ConstantApi from "../../../ConstantApi";
import Config from '../../../config';
import axiosCall from "../../axiosCall";
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import {
    GATE_PASS_LOADING,
    FETCH_GATE_PASS_MASTER_SUCCESS,
    FETCH_SINGLE_GATE_PASS_SUCCESS,
    FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS,
    CREATE_GATE_PASS_FORM,
    SET_UNIT_NAME_GATE_PASS,
    SET_START_DATE_GATE_PASS,
    SET_END_DATE_GATE_PASS,
    FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS,
    FETCH_PENDING_STYLE_SALE_ORDER_REQUEST,
    FETCH_PENDING_STYLE_SALE_ORDER_FAILURE,
    GATE_PASS_AUTHORIZED_SUCCESS,
} from './gatePass.actionsType';

// ---------------------------------------------------------------------------
// TODO #1: replace with whatever axios instance / base-URL helper your other
// action files already use (check the import at the top of
// accessoriesPoInwardHeader.action.js and swap it in here so auth headers /
// interceptors stay consistent with the rest of the app).
// ---------------------------------------------------------------------------
const BASE_URL = process.env.REACT_APP_API_URL || '';

// ---------------------------------------------------------------------------
// TODO #2: point these at your real backend routes/controller names.
// ---------------------------------------------------------------------------
const ENDPOINTS = {
    LIST: `${Config.baseUrl}/api/TblGatePass/GetTblGatePasses`, // GET    ?fromDate&toDate&unitId
    SINGLE: `${Config.baseUrl}/TblGatePass/GetSingle`, // GET    ?id
    CREATE: `${Config.baseUrl}/api/TblGatePass/CreateTblGatePass`, // POST   TblGatePass
    UPDATE: `${Config.baseUrl}/TblGatePass/Update`, // PUT    TblGatePass
    SOFT_DELETE: `${Config.baseUrl}/api/TblGatePass/DeleteTblGatePass`, // PUT    { fldId, fldDeletedBy }
    STATUS_DROPDOWN: `${Config.baseUrl}/TblGatePass/GetStatusDropdown`, // GET    -> [{ fldId, fldDescription }]    
    STYLE_SALE_ORDER_LOOKUP :  `${Config.baseUrl}${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=PENDINGSALE&UnitId=1`
};

const authHeaders = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
    dbname: Cookies.get('DATABASE')
});

// TODO #4: FldFKStatus references TblProperty (a shared property-master
// table). If you already have a generic "get property list by group id"
// action wired into a shared reducer (the way `fetchCommonPropertyById(46)`
// feeds `source`/`department` in your Accessories Inward screen), it's
// cleaner to reuse that instead of this dedicated endpoint — swap this thunk
// out for that call once you tell me the property-group id for Gate Pass
// statuses and which reducer key it lands in.
export const fetchGatePassStatusDropdown = () => async (dispatch) => {
    try {
        const { data } = await axios.get(ENDPOINTS.STATUS_DROPDOWN);
        dispatch({ type: FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS, payload: data?.data || [] });
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to fetch Gate Pass status list');
    }
};

// export const fetchGatePassMasterData = (fromDate, toDate, unitId) => async (dispatch) => {
//     try {
//         dispatch({ type: GATE_PASS_LOADING, payload: true });
//         const { data } = await axios.get(ENDPOINTS.LIST, { params: { fromDate, toDate, unitId }, headers: authHeaders() });
//         // TODO #3: adjust `data?.data` to match your API's actual response envelope.
//         dispatch({ type: FETCH_GATE_PASS_MASTER_SUCCESS, payload: data?.data || [] });
//     } catch (error) {
//         toast.error(error?.response?.data?.message || 'Failed to fetch Gate Pass list');
//     } finally {
//         dispatch({ type: GATE_PASS_LOADING, payload: false });
//     }
// };

export const fetchGatePassMasterData = (fromDate, toDate, unitId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        const { data } = await axios.get(ENDPOINTS.LIST, {
            params: { fromDate, toDate, unitId },
            headers: authHeaders()
        });
        // API may return a plain array, or wrap it as { data: [...] } / { Data: [...] }
        const list = Array.isArray(data) ? data : data?.data ?? data?.Data ?? [];
        dispatch({ type: FETCH_GATE_PASS_MASTER_SUCCESS, payload: Array.isArray(list) ? list : [] });
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to fetch Gate Pass list');
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};

export const getSingleGatePass = (id) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        const { data } = await axios.get(ENDPOINTS.SINGLE, { params: { id } });
        dispatch({ type: FETCH_SINGLE_GATE_PASS_SUCCESS, payload: data?.data });
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to fetch Gate Pass details');
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};

// Generic "set one field on the form" action — same role as
// createAccessoriesPoInwardMasterForm(key, value) in your existing module.
export const createGatePassForm = (key, value) => ({
    type: CREATE_GATE_PASS_FORM,
    key,
    value
});

export const createGatePass = (formData, fromDate, toDate, unitId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        await axios.post(ENDPOINTS.CREATE, formData, { headers: authHeaders()});
        toast.success('Gate Pass created successfully');
        dispatch(fetchGatePassMasterData(fromDate, toDate, unitId));
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to create Gate Pass');
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};

export const updateGatePass = (formData, fromDate, toDate, unitId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        await axios.put(ENDPOINTS.UPDATE, formData);
        toast.success('Gate Pass updated successfully');
        dispatch(fetchGatePassMasterData(fromDate, toDate, unitId));
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to update Gate Pass');
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};

// Soft delete: sets FldIsActive = false / FldDeletedBy / FldDeletedDt on the
// backend rather than removing the row — the schema already carries those
// audit columns, so we lean on them instead of a hard DELETE.
export const deleteGatePass = (id, fromDate, toDate, unitId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        await axios.delete(`${ENDPOINTS.SOFT_DELETE}/${id}`, { 
            headers: authHeaders() 
        });
        //await axios.delete(ENDPOINTS.SOFT_DELETE,  { params: { id } }, {  headers: authHeaders() });
        toast.success('Gate Pass deleted successfully');
        dispatch(fetchGatePassMasterData(fromDate, toDate, unitId));
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to delete Gate Pass');
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};

export const setUnitNameGatePass = (unitId) => ({
    type: SET_UNIT_NAME_GATE_PASS,
    payload: unitId
});

// export const fetchPendingStyleSaleOrderByProgram = (unitId) => async (dispatch) => {
//     try {
//         const { data } = await axios.get(ENDPOINTS.STYLE_SALE_ORDER_LOOKUP, {
//             params: { FldAction: 'PENDINGSALE', UnitId: unitId }
//         });
//         dispatch({ type: FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS, payload: data?.data || data || [] });
//     } catch (error) {
//         toast.error(error?.response?.data?.message || 'Failed to fetch pending Style / Sales Order list');
//     }
// };
export let fetchPendingStyleSaleOrderByProgram = (unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPOSalesOrderListNewApi}?FldAction=PENDINGSALE&UnitId=1`,        
        responseTypeSuccess: FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS,
        responseTypeRequest: FETCH_PENDING_STYLE_SALE_ORDER_REQUEST,
        responseTypeFailure: FETCH_PENDING_STYLE_SALE_ORDER_FAILURE,
    };
    return axiosCall(config);
};

// Authorize a Gate Pass (same approval API the other DC/PO screens use).
// ApprovalStatus 2 = Authorized, ProgramCode GPD = Gate Pass.
export const authorizeGatePass = (id) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_LOADING, payload: true });
        await axios.patch(
            `${Config.baseUrl}/api/TblYarnPO/UpdateTblYarnPOApproval?FldId=${id}&ApprovalStatus=2&ProgramCode=GPD`,
            null,
            { headers: authHeaders() }
        );
        dispatch({ type: GATE_PASS_AUTHORIZED_SUCCESS, payload: id });
        toast.success('Gate Pass authorized', { autoClose: 1500 });
        return true;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to authorize Gate Pass');
        return false;
    } finally {
        dispatch({ type: GATE_PASS_LOADING, payload: false });
    }
};
